import React from 'react';
import createElement from 'react-native-web/dist/exports/createElement';
import {StyleSheet, Text} from 'react-native';
import Themes from '../../themes';

const DateTimePickerWeb = ({label, date, onDateChange, minDate, maxDate}) => {
  const dateInput = createElement('input', {
    type: 'date',
    value: date,
    onInput: onDateChange,
    min: minDate,
    max: maxDate,
    style: styles.input,
  });

  return (
    <>
      <Text style={styles.label}>{label}</Text>
      {dateInput}
    </>
  );
};

const styles = StyleSheet.create({
  label: {
    color: '#BEBEBE',
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Roboto-Bold',
    marginBottom: 5,
  },
  input: {
    height: 45,
    borderColor: '#BEBEBE',
    padding: 10,
    borderWidth: 1,
    fontSize: 14,
    fontFamily: 'Roboto-Bold',
    color: Themes.colors.blue,
    marginBottom: 5,
  },
});

export default DateTimePickerWeb;
